<template>
  <div id="app">
    <router-view />
    <!-- <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition> -->
    <div class="music" @click="close()">
      <img
        :style="{ 'animation-play-state': musicState }"
        :src="
          stateIndex == 0
            ? require('../static/img/music.png')
            : require('../static/img/mus-stop.png')
        "
        alt=""
      />
    </div>
       
    <div class="audio">
           
      <!--隐藏audio标签-->
           
      <audio autoplay="autoplay" loop="loop" id="audioPublic">
               
        <source src="static/music/bgm.mp3" type="audio/mpeg" />
             
      </audio>
         
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      musicState: "",
      musicImg: require("../static/img/music.png"),
      stateIndex: 0,
    };
  },
  methods: {
    play() {
      //      let audioPublic=document.getElementById("audioPublic")
      const wxFakePlay = () =>
        WeixinJSBridge.invoke(
          "getNetworkType",
          {},
          () => audioPublic.play(),
          false
        );

      if (window.WeixinJSBridge) {
        wxFakePlay();
      } else {
        document.addEventListener(
          "WeixinJSBridgeReady",
          () => wxFakePlay(),
          false
        );
      }

      audioPublic.play();
    },
    close() {
      //      var audioPublic = document.getElementById('audioPublic');
      if (audioPublic.paused) {
        audioPublic.play(); // 播放
        this.musicState = "running";

        this.stateIndex = 0;
      } else {
        audioPublic.pause(); // 暂停
        this.musicState = "paused";
        this.stateIndex = 1;
      }
    },
  },
  // created() {
  //   //在页面刷新时将vuex里的信息保存到localStorage里
  //   window.addEventListener("beforeunload", () => {
  //     localStorage.setItem("messageStore", JSON.stringify(this.$store.state));
  //   });
  //   //在页面加载时读取localStorage里的状态信息
  //   localStorage.getItem("messageStore") &&
  //     this.$store.replaceState(
  //       Object.assign(
  //         this.$store.state,
  //         JSON.parse(localStorage.getItem("messageStore"))
  //       )
  //     );
  // },
  mounted() {
    var audioPublic = document.getElementById("audioPublic");
    this.play();
  },
};
</script>

<style scoped>
.music {
  width: 8%;
  position: fixed;
  top: 2%;
  right: 6%;
}
.music img {
  width: 100%;
  animation: rotate 2s infinite linear;
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

/* .fade-transform-leave-active,
.fade-transform-enter-active {
　　transition: all .5s;
}
.fade-transform-enter {
　　opacity: 0;
　　transform: translateX(-30px);
}
.fade-transform-leave-to {
 　 opacity: 0;
　　transform: translateX(30px);
} */

</style>




// WEBPACK FOOTER //
// src/App.vue